import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.sass']
})
export class StatusComponent implements OnInit {
  @Input() status: string;
  @Input() displayText: boolean;

  constructor() { }

  ngOnInit() {
  }
}
